import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Dropdown, Input, notification } from "antd";
import AccessControl from "components/common/AccessControl/accessControl";
import { CloseModal } from "components/icons";
import ThreeDotsIconComponent from "components/icons/TheeDotsIcon";
import DeleteIcon from "icons/DeleteIcon";
import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-modal";

const SocialAccounts = ({
  id,
  createSocialProfile,
  deleteSocialProfile,
  updateSocialProfile,
  getSocialProfiles,
  addSocialMediaPlatforms,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [editInput, setEditInput] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [editAccount, setEditAccount] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [showDetail, setShowDetail] = useState(null);

  const fetchSocialProfiles = useCallback(async () => {
    try {
      const response = await getSocialProfiles({ entityId: id });
      if (response?.value?.data?.length) {
        setProfileData(response?.value?.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [id, getSocialProfiles]);

  useEffect(() => {
    fetchSocialProfiles();
  }, [fetchSocialProfiles]);

  const createNewUserProfile = async () => {
    try {
      const { value } = await createSocialProfile({ entityId: id, title: input });
      if (value?.data) {
        fetchSocialProfiles();
        setIsOpen(false);
        notification["success"]({ message: "Profile created successfully" });
      } else {
        notification["error"]({ message: value?.error?.message || "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification["error"]({ message: error?.error?.message || "Something went wrong" });
    }
  };

  const addSocialMediaPlatform = async (account) => {
    const { value } = await addSocialMediaPlatforms({ profileId: account?.id, entityId: id });

    if (value?.data?.url) {
      window.open(value?.data?.url + "&logout=true", "_blank");
    } else {
      notification["error"]({ message: value?.message });
    }
  };

  const editSocialAccount = async () => {
    try {
      const { value } = await updateSocialProfile({
        entityId: id,
        title: editInput,
        profileId: editAccount?.id,
      });
      if (value?.data) {
        fetchSocialProfiles();
        setEditModalOpen(false);
        notification["success"]({ message: "Profile updated successfully" });
      } else {
        notification["error"]({ message: value?.error?.message || "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification["error"]({ message: error?.error?.message || "Something went wrong" });
    }
  };

  const deleteSocialAccount = async () => {
    try {
      const { value } = await deleteSocialProfile({
        entityId: id,
        profileId: deleteAccount?.id,
      });
      if (value?.data) {
        fetchSocialProfiles();
        setDeleteModalOpen(false);
        notification["success"]({ message: "Profile deleted successfully" });
      } else {
        notification["error"]({ message: value?.error?.message || "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification["error"]({ message: error?.error?.message || "Something went wrong" });
    }
  };

  const deleteModalFunc = () => {
    return (
      <Modal
        isOpen={deleteModalOpen}
        ariaHideApp={false}
        onRequestClose={() => setDeleteModalOpen(false)}
        contentLabel="Delete Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Delete</h5>
          </div>
          <div className="react-modal-body text-center">
            <h6 className="react-modal-body-text">Are you sure you want to delete?</h6>
          </div>
          <div className="react-modal-footer text-center">
            <div className="react-foo-container">
              <button type="button" onClick={() => setDeleteModalOpen(false)} className="btn btn-white">
                Close
              </button>
              <button type="button" onClick={() => deleteSocialAccount()} className="btn btn-primary">
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  const editModalFunc = () => {
    return (
      <Modal
        isOpen={editModalOpen}
        ariaHideApp={false}
        onRequestClose={() => setDeleteModalOpen(false)}
        contentLabel="Delete Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit</h5>
          </div>
          <div className="react-modal-body">
            <div className="form-group">
              <label className="form-label">
                Profile Name <span className="required">*</span>
              </label>
              <Input className="form-control" value={editInput} onChange={(e) => setEditInput(e.target.value)} />
            </div>
          </div>

          <div className="react-modal-footer text-center">
            <div className="react-foo-container">
              <button type="button" onClick={() => setEditModalOpen(false)} className="btn btn-white">
                Close
              </button>
              <button type="button" onClick={() => editSocialAccount()} className="btn btn-primary">
                Edit
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  const handleClick = (data) => {
    setShowDetail(data);
  };

  const items = [
    {
      label: (
        <AccessControl code="delete_socialAccounts" page="organization-profile">
          <a
            onClick={() => {
              setDeleteModalOpen(true);
              setDeleteAccount(showDetail);
            }}
          >
            <DeleteIcon />
            <span>Delete</span>
          </a>
        </AccessControl>
      ),
      key: "1",
    },
  ];

  return (
    <>
      {deleteModalFunc()}
      {editModalFunc()}
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add Profile</h5>
            <button type="button" onClick={() => setIsOpen(false)} className="btn btn__default">
              <CloseModal />
            </button>
          </div>

          <div className="react-modal-body">
            <div className="form-group">
              <label className="form-label">
                Profile Name <span className="required">*</span>
              </label>
              <Input className="form-control" onChange={(e) => setInput(e.target.value)} />
            </div>
            <button className="btn btn-primary" disabled={!input} onClick={() => createNewUserProfile()}>
              Add
            </button>
          </div>
        </div>
      </Modal>

      <div className="right-container--op">
        <div className="title-block--op">
          <div>
            <h4>Social accounts</h4>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              <AccessControl code="create_socialAccounts" page="organization-profile">
                <button class="btn btn-primary" onClick={() => setIsOpen(true)}>
                  Create new profile
                </button>
              </AccessControl>
            </div>
          </div>
        </div>
        <div className="table-resposive table-container user-management-table normal-table-block">
          <table className="table">
            <thead>
              <tr>
                <th>PROFILE NAME</th>
                <th>PLATFORM</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {profileData?.map((e) => {
                return (
                  <tr>
                    <td>{e?.title}</td>
                    <td>magnifi.ai</td>
                    <td>
                      <div className="table-action-block d-flex gap-3">
                        <AccessControl code="edit_socialAccounts" page="organization-profile">
                          <a
                            onClick={() => {
                              setEditModalOpen(true);
                              setEditAccount(e);
                              setEditInput(e?.title);
                            }}
                          >
                            <EditOutlined />
                          </a>
                        </AccessControl>

                        <AccessControl code="ayrshare_socialAccounts" page="organization-profile">
                          <a
                            onClick={() => {
                              addSocialMediaPlatform(e);
                            }}
                          >
                            <PlusCircleOutlined />
                          </a>
                        </AccessControl>
                        <Dropdown
                          onClick={() => {
                            handleClick(e);
                          }}
                          menu={{
                            items,
                          }}
                          className=""
                          trigger={["click"]}
                          overlayClassName={"tableActionBlock"}
                          placement={"bottomRight"}
                        >
                          <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                            <ThreeDotsIconComponent />
                          </a>
                        </Dropdown>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SocialAccounts;
